module.exports = __webpack_public_path__ + "img/logo-m2n.c3c77784.svg";